<style lang="scss">
.page-handle {
  min-height: 100vh;

  & > div {
    height: calc(100vh - 10px);
  }
}
</style>
<template>
  <div class="a-page page-handle">
    <div>
      <div class="text-center" style="padding-top:calc(50vh - 100px)">
        <div>
          <img src="/static/img/logo.png" alt="Atosa" style="max-width:80px;">
        </div>
        <div style="padding-top:20px;">
          <span style="color:black; font-weight: 600; font-size:15px;">WELCOME</span>
          <div>{{ $t('base.logging_please_wait')}} ...</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'page__handle-sign',
  data () {
    return {}
  },
  beforeMount () {
    console.log(this.$route.query.token)
    console.log(this.$route.query.redirect)
    this.$route.query.redirect = this.$route.query.redirect.replace(/\?{2,}/, '?')
    console.log(this.$route.query.redirect)
    if (typeof this.$route.query.token === 'undefined') {
      this.m__to_login()
    } else {
      this.m__get_update_info()
    }
  },
  methods: {
    m__to_login () {
      this.$router.push(`/login${typeof this.$route.query.redirect !== 'undefined' ? `?r=${this.$route.query.redirect}` : ''}`)
    },
    m__get_update_info () {
      this.$http.get(this.API.profile, {headers: {Authorization: this.$route.query.token}})
          .then(resp => {
            let data = resp.body.data
            localStorage.setItem('session', JSON.stringify(data))
            this.$store.dispatch('set__user_info', data)
            if (this.$route.query.redirect) {
              // this.$router.push(this.$route.query.redirect)
              window.location = this.$route.query.redirect + `&token=${this.$route.query.token}&target=0`
            } else {
              this.$router.push('/')
            }

          })
          .catch(error => {
            this.m__to_login()
          })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/sign/handle.vue